import * as React from "react";
import { observable, computed, action } from "mobx";
import { observer, inject } from "mobx-react";
import { NotificationStore } from "../Stores/NotificationStore";
import { CollectionPrivilegeInfoEdit } from "./CollectionPrivilegesEdit.Info";
import * as DocumentManagement from "../DocumentManagement";
import { getDocumentPrivilegeNamesAsync } from "../Strings";
import { InputBoolean, PrivilegeMembership } from "../Shared";
import { CollectionStoreImpl } from "../Stores/CollectionStore";
import { Strings } from "../Stores/StringsStore";
import * as Utilities from "../Utilities";
import { DialogStore, DialogResult } from "../Stores/DialogStore";


interface ICollectionPrivilegesEditProps {
	collection: DocumentManagement.CollectionDetails;
	store?: CollectionStoreImpl;
}

@inject('store')
@observer
export class CollectionPrivilegesEdit extends React.Component<ICollectionPrivilegesEditProps, {}> {

	@observable searchTerm: string = "";
	@observable isForCurrentCollectionOnly: InputBoolean;
	@observable privilegesNames: string[] = [];
	searchTimeoutHandle: number;

	componentWillMount() {
		this.isForCurrentCollectionOnly = new InputBoolean();
		this.isForCurrentCollectionOnly.label = "For current Collection";
		this.isForCurrentCollectionOnly.value = false;
		this.props.store.handlePrivilegesDelete = this.handlePrivilegesDelete;
		let uiLang = Utilities.getUiLanguage();
		if (!uiLang) {
			uiLang = "en-US";
		}
		getDocumentPrivilegeNamesAsync(uiLang).then(names => this.privilegesNames = names);
	}


	getGroupPrivileges() {
		DocumentManagement.queryCollectionPrivilegeInfosAsync({ collectionId: this.props.collection.guid, searchTerm: this.searchTerm }).then(result => {
			this.props.collection.privileges = result;
		}).catch(error => {
			DialogStore.showError(Strings.general.errorDialogTitle, error);
		});
	}

	handleSearchTermChange = (event: React.FormEvent<any>) => {
		this.searchTerm = (event.target as any).value as string;
		clearTimeout(this.searchTimeoutHandle);
		this.searchTimeoutHandle = setTimeout(() => this.getGroupPrivileges(), 300);
	}

	handleNoPrivilegeSpanClick = () => {
		this.props.store.collectionPrivilegesWizardState.open();
	}

	@action handlePrivilegesDelete = () => {
		DialogStore.show(Strings.documentManagement.collectionEdit.deletePrivilegesDialogTitle, Strings.documentManagement.collectionEdit.deletePrivilegesDialogText).then(result => {
			if (result == DialogResult.Yes) {
				this.props.store.addedPrivileges = this.props.store.addedPrivileges.filter(p => this.props.store.selectedPrivileges.indexOf(p) < 0);
				this.props.store.selectedPrivileges.forEach(p => {
					if (this.props.collection.privileges.privilegesForGroups.remove(p)) {
						this.props.store.removedCollectionPrivileges.push(p);
					}
					p.privilegeMemberships.forEach(m => m.isExplicitMemberOf = false);
				});
				this.props.store.selectedPrivileges.clear();
				this.props.store.updateImplicitPrivileges(this.props.collection);
			}
		});
	}

	@computed get privilegeListClass(): string {
		return this.props.store.privilegeSelectionMode ? "list-advanced is--selection" : "list-advanced";
	}

	render() {
		//List the existing privileges and selected privileges

		return this.privilegesNames.length != 0 && (this.props.collection.privileges.privilegesForGroups.length > 0 || this.props.store.addedPrivileges.length > 0) ? <div className={this.privilegeListClass}>

			<table className="is--type-mobile is--rotate-headers" data-test-id="privileges" >
				<thead>
					<tr>
						<th key="groupName"></th>
						{this.props.store.privilegeSelectionMode ? <th></th> : null}
						{this.privilegesNames.map(name => {
							return <th className="short-header" key={name} title={name}>
								<div>
									<span>{name}</span>
								</div>
							</th>
						})}
					</tr>
				</thead>
				<tbody>
					{this.props.collection.privileges.privilegesForGroups.map(item => {
						return <CollectionPrivilegeInfoEdit key={item.groupId} groupId={item.groupId} collection={this.props.collection} item={item} />
					})}

					{this.props.store.addedPrivileges.map(item => {
						return <CollectionPrivilegeInfoEdit key={item.groupId} groupId={item.groupId} collection={this.props.collection} item={item} />
					})}
				</tbody>
			</table>
		</div> :
			<div className="inside__note is--clickable-note" onClick={this.handleNoPrivilegeSpanClick}>
				<span>
					{Strings.documentManagement.collectionEdit.collectionEmptyPrivilegeResultText}
				</span>
			</div>;
	}
}


